export const statusNotifications: TableModule = {
    name: "statusNotifications",
    route: "spa.basedata.statusNotifications",
    defaultOrder: {
        column: "id",
        direction: "asc"
    },
    columns: [
        {
            name: "organisation",
            sortable: true,
            sortBy: "customOrderOrganisation",
            mobile: true
        }, {
            name: "mailTemplate",
            sortable: true,
            sortBy: "customOrderMailTemplate",
        }, {
            name: "notification_mode",
            mobile: true,
        }, {
            name: "sendTo",
            mobile: true
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            name: "statusNotifications.create",
            isCreateAction: true,
            ability: [
                "create",
                "statusNotifications"
            ]
        }
    ]
}